import { BookedSlide, PhotoSlide, VideoSlide } from '../../../components/Carousel';
import { EMediaType, IMedia } from '../../../types';

const SLIDE_MAP = {
  [EMediaType.Photo]: PhotoSlide,
  [EMediaType.Layout]: PhotoSlide,
  [EMediaType.CianLayout]: PhotoSlide,
  [EMediaType.Video]: VideoSlide,
};

export const renderSlide = (slide: IMedia, position: number) => {
  const Slide = SLIDE_MAP[slide.type];

  if (!slide.withBookedOverlay) {
    return <Slide key={`slide-${position}`} {...slide} />;
  }

  return (
    <BookedSlide key={`slide-${position}`}>
      <Slide {...slide} />
    </BookedSlide>
  );
};
